
import * as THREE from 'three'
import References from '@/singletons/references'
import MaterialCreateService from '@/services/Three/material-create.service'
import { useStore } from '@/store'
import { defineComponent } from 'vue'
import { computed, watch } from 'vue'
import TextureLoadService from '@/services/Three/texture-load.service'
import SentrySingleton from '@/singletons/sentry-singleton'

export default defineComponent({
  name: 'RandselTransparent',
  setup() {
    const store = useStore()
    const isBagLoaded = computed(() => store.getters.isBagLoaded)

    let materialCreateService: MaterialCreateService
    let textureLoadService: TextureLoadService

    // prettier-ignore
    watch(() => isBagLoaded.value, (_) => {
        try {
          materialCreateService = new MaterialCreateService()
          textureLoadService = new TextureLoadService(References.instance.getSceneReferences().maxAnisotropy)
          var mat = new THREE.MeshStandardMaterial({ opacity: 0.3, transparent: true });
          mat.color = materialCreateService.createColor(0xFFFFFF)
          mat['skinning'] = true
          textureLoadService.loadImage('default/transparent', (tex: THREE.Texture | null) => {
            mat.map = tex
            mat.needsUpdate=true
          })
          mat.dithering = true
          References.instance.getBagReferences().transparent.material = mat
        }
        catch(err) {
          SentrySingleton.instance.captureException(err)
        }
      }
    )

    return {
      isBagLoaded
    }
  }
})
